<template>
  <v-container fluid>
    <!-- <el-overlay-loading :loading="pageloading" /> -->
    <h3 class="mt-3 mb-0">Perduotų pranešimų peržiūra</h3>
    <hipoteka-perduoti :key="perduotiKey" :readonly="hipotekaReadonly" />

    <template v-if="showPaslaugos">
      <h3 class="mt-3 mb-0">Paslaugos užsakymo informacija</h3>
      <hipoteka-paslaugos :key="paslaugosKey" :readonly="hipotekaReadonly" />
    </template>

    <template v-if="showNtrCheck">
      <hipoteka-ntr-check :key="ntrCheckKey" :readonly="hipotekaReadonly" />
    </template>

    <hipoteka-istorija duomenys="registrui" />

    <modal-busena
      :key="modalBusenaKey"
      v-model="showModalBusena"
      :busena="modalBusena"
      :busena-tekstui="modalBusenaTekstui"
      :is-sign="modalBusenaWithSign"
      :perskaiciuoti-termina="perskaiciuotiTermina"
      @confirmBusena="confirmBusena"
      @loadedBusena="loadedBusena"
    />

    <modal-turtas-check
      v-model="showTurtasCheck"
      @savedData="updatePaslaugos()"
    />
    <modal-asmuo-check
      v-model="showAsmuoCheck"
      @savedData="updatePaslaugos()"
    />

    <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      :item="confirmItem"
      :action="confirmAction"
      v-model="showConfirm"
      @confirmPriskirtiNtr="priskirtiNtr"
    />

    <v-footer class="form-footer">
      <el-button
        v-if="validate('Perduoti')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Perduoti</el-button
      >
      <el-button
        v-if="validate('Pasirašyti perduotas')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Pasirašyti</el-button
      >
      <el-button
        v-if="validate('Pasirašyti grazintas')"
        primary
        @click.native="openBusena(grazintas)"
        :loading="loading"
        >Pasirašyti</el-button
      >
      <el-button
        v-if="validate('Pasirašyti atmestas')"
        primary
        @click.native="openBusena(atmestas)"
        :loading="loading"
        >Pasirašyti</el-button
      >
      <el-button
        v-if="validate('Pasirašyti kreditorius')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Pasirašyti</el-button
      >
      <el-button
        v-if="validate('Netvirtinti kreditorius')"
        @click.native="openBusena(rengiamas)"
        :loading="loading"
        >Netvirtinti</el-button
      >
      <el-button
        v-if="validate('Patvirtinti savitarna')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Patvirtinti</el-button
      >
      <el-button
        v-if="validate('Pasirašyti savitarna')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Pasirašyti</el-button
      >
      <el-button
        v-if="validate('Netvirtinti savitarna')"
        primary
        @click.native="openBusena(rengiamas)"
        :loading="loading"
        >Netvirtinti</el-button
      >
      <el-button
        v-if="validate('Perduoti sutartis savitarna')"
        primary
        @click.native="openBusena(perduotas)"
        :loading="loading"
        >Perduoti</el-button
      >
      <el-button
        v-if="validate('Apmoketi savitarna')"
        primary
        @click.native="moketiSavitarna()"
        :loading="loading"
        >Mokėti</el-button
      >
      <el-button
        v-if="validate('Registruoti')"
        primary
        @click.native="openBusena(iregistruotas)"
        :loading="loading"
        >Registruoti</el-button
      >
      <el-button
        v-if="validate('Grąžinti tikslinti')"
        @click.native="openBusenaGrazintas(grazintas)"
        :loading="loading"
        >Grąžinti tikslinti</el-button
      >
      <el-button
        v-if="validate('Atmesti')"
        @click.native="openBusena(atmestas)"
        :loading="loading"
        >Atmesti</el-button
      >

      <el-button
        v-if="validate('Turtų tikrinimas')"
        @click.native="turtasCheck()"
        :loading="loading"
        >Turtų tikrinimas</el-button
      >
      <el-button
        v-if="validate('Asmenų tikrinimas')"
        @click.native="asmuoCheck()"
        :loading="loading"
        >Asmenų tikrinimas</el-button
      >

      <v-spacer></v-spacer>
      <el-button
        v-if="validate('Priskirti sau')"
        @click.native="priskirtiSau()"
        :loading="loading"
        >Priskirti sau</el-button
      >
      <el-button
        v-if="validate('Grąžinti NTR')"
        @click.native="priskirtiConfirm()"
        :loading="loading"
        >Grąžinti NTR</el-button
      >
      <el-button
        v-if="validate('Word')"
        @click.native="printWord()"
        :loading="loading"
        >Word</el-button
      >
      <el-button
        v-if="validate('Tikrinti')"
        primary
        @click.native="checkErrors()"
        :loading="loading"
        >Tikrinti</el-button
      >
    </v-footer>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '../../../mixins/userRole'
import busena from '../../../mixins/busena'
import HipotekaMap from '../hipotekaMap'
import HipotekaPerduoti from './HipotekaPerduoti'
import HipotekaPaslaugos from './HipotekaPaslaugos'
import HipotekaNtrCheck from './HipotekaNtrCheck'
import HipotekaIstorija from './../istorija/HipotekaIstorija'
import ModalTurtasCheck from '../../modals/ModalTurtasCheck'
import ModalAsmuoCheck from '../../modals/ModalAsmuoCheck'
import ModalBusena from '../../modals/ModalBusena'
import checkErrors from '../../../mixins/checkErrors'
import math from '../../../mixins/math'
import ModalConfirm from '../../modals/ModalConfirm'

export default {
  name: 'HipotekaRegistravimas',
  components: {
    HipotekaPerduoti,
    HipotekaPaslaugos,
    HipotekaNtrCheck,
    HipotekaIstorija,
    ModalTurtasCheck,
    ModalAsmuoCheck,
    ModalBusena,
    ModalConfirm,
  },
  mixins: [userRole, busena, checkErrors, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      uploadDialog: false,
      showModalBusena: false,
      modalBusenaWithSign: false,
      modalBusena: null,
      modalBusenaTekstui: null,
      modalBusenaRefresh: 0,
      registravimasRefresh: 0,
      showTurtasCheck: false,
      showAsmuoCheck: false,
      confirmTitle: null,
      confirmText: null,
      confirmItem: null,
      confirmAction: null,
      showConfirm: false,
      perskaiciuotiTermina: false,
    }
  },
  computed: {
    ...mapGetters([
      'appSavitarna',
      'objektasID',
      'hipotekaTipas',
      'hipotekaReadonly',
      'hipotekaOwner',
      'pasirasymasVadovas',
      'signBusena',
      'signStatus',
      'savitarnaKrepselisUrl',
      'registratoriaiAktyvus',
      'hipotekaBusenaTolimesne',
    ]),
    modalBusenaKey() {
      return `busena-${this.modalBusenaRefresh}`
    },
    perduotiKey() {
      return `perduoti-${this.registravimasRefresh}`
    },
    paslaugosKey() {
      return `paslaugos-${this.registravimasRefresh}`
    },
    rinkmenosKey() {
      return `rinkmenos-${this.registravimasRefresh}`
    },
    ntrCheckKey() {
      return `ntrcheck-${this.registravimasRefresh}`
    },
    showPaslaugos() {
      return (
        this.isRengiamas ||
        this.isGrazintas ||
        this.isPerduotas ||
        this.isIregistruotas ||
        this.isAtmestas ||
        (this.appSavitarna && this.hipotekaOwner)
      )
    },
    showNtrCheck() {
      return (this.isPerduotas || this.isIregistruotas) && this.roleRG
    },
    isSutartis() {
      return this.hipotekaTipas.includes('sutartis')
    },
    isPabaiga() {
      return (
        this.hipotekaTipas.includes('pabaiga') ||
        this.hipotekaTipas.includes('panaikinimas')
      )
    },
    isSign() {
      return this.$route.params.sign
    },
    needSavitarnaSign() {
      return this.signStatus === 'not_signed' || this.signStatus === 'signing'
    },
    dokumentasTipas() {
      return HipotekaMap['hipotekaTipas'][this.hipotekaTipas]
        ? HipotekaMap['hipotekaTipas'][this.hipotekaTipas].title
        : this.hipotekaTipas
    },
  },
  created() {
    this.pageloading = false
    this.loading = false
    if (this.isSign && this.signBusena) {
      this.openBusena(this.signBusena, true)
    }
  },
  methods: {
    openBusenaGrazintas(busena) {
      this.perskaiciuotiTermina = true
      this.openBusena(busena)
    },
    openBusena(busena, withSign = false, busenaTekstui = null) {
      this.loading = true
      this.modalBusenaWithSign = withSign
      if (!withSign) {
        this.$store.dispatch('signType', null)
      }
      this.modalBusena = busena
      this.modalBusenaTekstui = busenaTekstui ?? busena
      this.modalBusenaRefresh++
      this.showModalBusena = true

      this.loading = false
    },
    confirmBusena() {
      this.registravimasRefresh++
      this.$root.$emit('reloadHipotekaTab')
    },
    loadedBusena() {
      this.perskaiciuotiTermina = false
    },
    validate(button) {
      let ans = false

      switch (button) {
        case 'Perduoti':
          ans =
            (this.isRengiamas || this.isGrazintas) &&
            (this.roleDT || (this.roleRG && this.hipotekaOwner)) &&
            !this.pasirasymasVadovas &&
            !this.hipotekaReadonly
          break
        case 'Pasirašyti perduotas':
          ans =
            (this.isRengiamas || this.isGrazintas) &&
            this.pasirasymasVadovas &&
            this.roleOr(['DT_notaras', 'DT_notaro_atstovas'])
          break
        case 'Pasirašyti grazintas':
          ans =
            (this.isPerduotas || this.isGrazintas || this.isNepatikslintas) &&
            this.hipotekaBusenaTolimesne === 'grazintas' &&
            this.pasirasymasVadovas &&
            this.role('RG_NTR_vadovas')
          break
        case 'Pasirašyti atmestas':
          ans =
            (this.isPerduotas || this.isGrazintas || this.isNepatikslintas) &&
            this.hipotekaBusenaTolimesne === 'atmestas' &&
            this.pasirasymasVadovas &&
            this.role('RG_NTR_vadovas')
          break
        case 'Pasirašyti kreditorius':
          ans =
            this.isLaukiaPatvirtinimo &&
            this.hipotekaBusenaTolimesne === 'laukia_apmokejimo' &&
            (this.signStatus === 'not_signed' ||
              this.signStatus === 'signing') &&
            this.roleOr(['DT_JA'])
          break
        case 'Netvirtinti kreditorius':
          ans =
            this.isLaukiaPatvirtinimo &&
            this.hipotekaBusenaTolimesne === 'laukia_apmokejimo' &&
            (this.signStatus === 'not_signed' ||
              this.signStatus === 'signing') &&
            this.roleOr(['DT_JA'])
          break
        case 'Patvirtinti savitarna':
          ans =
            this.appSavitarna &&
            !this.isSutartis &&
            (this.isRengiamas || this.isGrazintas) &&
            this.roleEL &&
            this.hipotekaOwner &&
            !this.hipotekaReadonly
          break
        case 'Pasirašyti savitarna':
          ans =
            this.appSavitarna &&
            this.isLaukiaPatvirtinimo &&
            this.needSavitarnaSign &&
            this.roleEL
          break
        case 'Netvirtinti savitarna':
          ans =
            this.appSavitarna &&
            this.isLaukiaPatvirtinimo &&
            this.needSavitarnaSign &&
            this.roleEL
          break
        case 'Apmoketi savitarna':
          ans =
            this.appSavitarna &&
            this.isLaukiaApmokejimo &&
            this.hipotekaOwner &&
            this.roleEL
          break
        case 'Perduoti sutartis savitarna':
          ans =
            this.appSavitarna &&
            this.isSutartis &&
            (this.isRengiamas || this.isGrazintas) &&
            this.roleEL &&
            this.hipotekaOwner &&
            !this.hipotekaReadonly
          break
        case 'Registruoti':
          ans =
            this.isPerduotas &&
            this.roleRG &&
            !this.pasirasymasVadovas &&
            !this.hipotekaReadonly
          break
        case 'Grąžinti tikslinti':
          ans =
            this.isPerduotas &&
            this.roleRG &&
            !this.pasirasymasVadovas &&
            !this.hipotekaReadonly
          break
        case 'Atmesti':
          ans =
            (this.isPerduotas ||
              this.isGrazintas ||
              (this.isNepatikslintas &&
                ((this.role('RG_STSR_registrat') &&
                  this.registratoriaiAktyvus === 'STSR') ||
                  (this.role('RG_NTR_registrat') &&
                    this.registratoriaiAktyvus === 'NTR')))) &&
            this.roleRG &&
            !this.pasirasymasVadovas &&
            (!this.hipotekaReadonly ||
              this.isGrazintas ||
              (this.isNepatikslintas &&
                ((this.role('RG_STSR_registrat') &&
                  this.registratoriaiAktyvus === 'STSR') ||
                  (this.role('RG_NTR_registrat') &&
                    this.registratoriaiAktyvus === 'NTR'))))
          break
        case 'Turtų tikrinimas':
          ans =
            !this.isSutartis &&
            !this.isPabaiga &&
            (this.isRengiamas || this.isGrazintas) &&
            (this.roleOr([
              'DT_notaras',
              'DT_notaro_padejejas',
              'DT_notaro_atstovas',
            ]) ||
              (this.roleRG && this.hipotekaOwner)) &&
            !this.pasirasymasVadovas &&
            !this.hipotekaReadonly
          break
        case 'Asmenų tikrinimas':
          ans =
            !this.isSutartis &&
            !this.isPabaiga &&
            (this.isRengiamas || this.isGrazintas) &&
            (this.roleOr([
              'DT_notaras',
              'DT_notaro_padejejas',
              'DT_notaro_atstovas',
            ]) ||
              (this.roleRG && this.hipotekaOwner)) &&
            !this.pasirasymasVadovas &&
            !this.hipotekaReadonly
          break
        case 'Tikrinti':
          ans =
            !this.isIregistruotas &&
            (!this.appSavitarna || this.isRengiamas || this.isGrazintas) &&
            (this.roleDT || this.roleRG || this.roleEL)
          break
        case 'Word':
          ans =
            !this.appSavitarna &&
            !this.isSutartis &&
            (this.roleRG ||
              this.roleOr([
                'DT_notaras',
                'DT_notaro_padejejas',
                'DT_notaro_atstovas',
              ]))
          break
        case 'Priskirti sau':
          ans =
            !this.appSavitarna &&
            this.roleRG &&
            !(
              this.pasirasymasVadovas && this.registratoriaiAktyvus === 'NTR'
            ) &&
            (this.isPerduotas || this.isGrazintas || this.isNepatikslintas)
          break
        case 'Grąžinti NTR':
          ans =
            !this.appSavitarna &&
            this.role('RG_STSR_registrat') &&
            this.registratoriaiAktyvus === 'STSR' &&
            !this.isSutartis &&
            this.isPerduotas
          break
      }

      // ans = ans && !this.hipotekaReadonly
      return ans
    },
    turtasCheck() {
      this.showTurtasCheck = true
    },
    asmuoCheck() {
      this.showAsmuoCheck = true
    },
    updatePaslaugos() {
      this.registravimasRefresh++
    },
    moketiSavitarna() {
      this.loading = true

      const data = { obj_id: this.objektasID }

      this.$axios
        .post(`objektas/${this.objektasID}/busena/apmoketas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('checkErrors', null)
          if (res.data.krepselis) {
            this.gotoKrepselis(res.data.krepselis_id)
          } else {
            this.loading = false
            this.confirmBusena()
          }
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    printWord() {
      this.loading = true

      const data = { obj_id: this.objektasID }

      this.$axios
        .get(`objektas/${this.objektasID}/perziura/word`, {
          responseType: 'arraybuffer',
        })
        .then(res => {
          this.openFile(res.data)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err)
          // window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    priskirtiSau() {
      this.loading = true

      const data = {}

      this.$axios
        .post(`objektas/${this.objektasID}/tikrina`, data)
        .then(res => {
          this.loading = false
          this.$root.$emit('reloadHipotekaTab')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    priskirtiConfirm() {
      this.confirmTitle = 'Grąžinti NTR'
      this.confirmText =
        'Ar tikrai norite grąžinti pranešimą NTR registratoriui pakartotiniam tikrinimui?'
      this.confirmAction = 'PriskirtiNtr'
      this.showConfirm = true
    },
    priskirtiNtr() {
      this.loading = true

      const data = {}

      this.$axios
        .post(`objektas/${this.objektasID}/priskirti-ntr-registratoriui`, data)
        .then(res => {
          this.loading = false
          this.$root.$emit('reloadHipotekaTab')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
          this.loading = false
        })
    },
    openFile(fileData) {
      var fileURL = window.URL.createObjectURL(new Blob([fileData]))
      var fileLink = document.createElement('a')
      fileLink.href = fileURL
      fileLink.setAttribute(
        'download',
        this.safeFileName(`${this.dokumentasTipas}.docx`)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    gotoKrepselis(krepselis_id = null) {
      this.loading = true
      if (krepselis_id) {
        window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}basketDetails.do?basketId=${krepselis_id}`
        return
      }
      window.location.href = this.savitarnaKrepselisUrl
    },
  },
}
</script>
